export const VAPI_ASSISTANT_IDS = {
  male: '3bdcf139-ca78-49e1-a6c0-be90fcaa42f8',
  female: '61fe37d1-5ec4-40ba-a811-6ed0951feaca'
} as const;

export type VoiceGender = keyof typeof VAPI_ASSISTANT_IDS;

export function getAssistantIdForGender(gender: VoiceGender): string {
  return VAPI_ASSISTANT_IDS[gender];
}
